import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class WelcomePagePaths {
  static welcome = new EnhancedPath('/welcome');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: WelcomePagePaths.welcome.path,
      component: lazyWithRetry(() => import('app/pages/welcome')),
      exact: true,
      isAllowedWithoutRoles: true,
    },
  ],
};

export default routesConfig;
